import PropTypes from 'prop-types';
import { forwardRef, useState } from 'react';
import { createPortal } from 'react-dom';
import useIsomorphicLayoutEffect from 'use-isomorphic-layout-effect';

var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  }

  if (typeof ref === 'object' && ref !== null) {
    ref.current = value;
  }
};

var DocumentPortal = /*#__PURE__*/forwardRef(function DocumentPortal(_ref, ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children;

  var _useState = useState(null),
      node = _useState[0],
      setNode = _useState[1];

  useIsomorphicLayoutEffect(function () {
    setNode(document.createElement(as));
  }, [as]);
  useIsomorphicLayoutEffect(function () {
    if (node) {
      document.body.appendChild(node);
      return function () {
        node.parentNode.removeChild(node);
      };
    }
  }, [node]);
  useIsomorphicLayoutEffect(function () {
    if (ref) {
      updateRef(ref, node);
      return function () {
        updateRef(ref, null);
      };
    }
  }, [node, ref]);
  return node && /*#__PURE__*/createPortal(children, node);
});

if (process.env.NODE_ENV !== 'production') {
  DocumentPortal.propTypes = {
    as: PropTypes.string,
    children: PropTypes.node
  };
}

export default DocumentPortal;
